export interface ReaderPreferences {
  fontSize:number
  lineHeight:number
  theme:'paper'|'white'|'night'
  discoverable:boolean
  allowRequests:boolean
  showBio:boolean
  reminderEnabled:boolean
  reminderTime:string
  reminderDays:number[]
}
export type RoomKind='flying'|'relay'|'reading'
export const defaultPreferences:ReaderPreferences={fontSize:22,lineHeight:2,theme:'paper',discoverable:true,allowRequests:true,showBio:true,reminderEnabled:false,reminderTime:'20:00',reminderDays:[0,1,2,3,4,5,6]}
export function normalizeLine(value:string){return value.normalize('NFKC').replace(/[^\p{Script=Han}\p{L}\p{N}]/gu,'')}
export function poemVerses(poem:{content:string}){return poem.content.split(/[，。！？；、\n]/).map(x=>x.trim()).filter(x=>normalizeLine(x).length>=3)}
